import React from "react";
import FillerPromptsSectionGroup from './FillerPromptsSectionGroup';
import { LanguageSelector, TtsVoiceSelector } from "../form_features";
import { getGlobalSettings } from "../stores";
import { defaultTtsVoice } from '../types';

/**
 * JSDoc imports.
 * @import {
 *   Design,
 *   DesignFillerPrompt,
 *   LanguageCode,
 *   TextToSpeechVoiceOrDefault
 * } from "../types";
 */

export default class FillerPrompts extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            prompts: this.props.prompts
        };
        this.forceUpdate = this.forceUpdate.bind(this);
    }

    /**
     * @param {string} valKey
     * @param {{
     *   idx: number;
     *   lang: LanguageCode;
     *   type: keyof(Design['fillerPrompts']);
     *   value: string;
     * }}
     */
    setConfig(valKey, { idx, lang, type, value }) {
        if (valKey === 'prompt') {
            const { ttsVoices } = getGlobalSettings();
            
            /** @type { TextToSpeechVoiceOrDefault } */
            const ttsVoice = ttsVoices?.[lang] ?? defaultTtsVoice;
            const { ttsOverrides } = window.apm.serialized.rootSettings.features;

            /** @type { DesignFillerPrompt } */
            let prompt = window.apm.serialized.fillerPrompts[type][idx];

            let transcriptIndex = prompt.transcripts.findIndex(({ locale }) => locale === lang);
            transcriptIndex = transcriptIndex === -1 ? prompt.transcripts.length : transcriptIndex;

            if (ttsOverrides && ttsVoice && ttsVoice !== defaultTtsVoice) {
                prompt.ttsOverrides ??= {};
                prompt.ttsOverrides[lang] ??= {};
                prompt.ttsOverrides[lang][ttsVoice] ??= {};
                prompt.ttsOverrides[lang][ttsVoice].text = value;
            } else {
                const transcriptObject = {
                    ...(prompt.transcripts[transcriptIndex] ?? { locale: lang }),
                    transcript: value
                };
                prompt.transcripts ??= [];
                prompt.transcripts[transcriptIndex] = transcriptObject;
            }
            prompt.lastLocalChange = window.apm.timestamp;
            window.apm.serialized.fillerPrompts[type][idx] = prompt;

            window.apm.setSerializedChanged();
            this.setState({ prompts: window.apm.serialized.fillerPrompts });
        }
        if (valKey === 'externalAudioServiceUrl' || valKey === 'externalAudioPrompt') {
            window.apm.serialized.fillerPrompts[type][idx][valKey] = value;
            window.apm.serialized.fillerPrompts[type][idx].lastLocalChange = window.apm.timestamp;
            window.apm.setSerializedChanged();
        }
    }

    getConfig(key, props = null) {
        if (key === "lang") {
            return getGlobalSettings().language;
        }
        if (key === "externalAudioServiceUrl" || key == "externalAudioPrompt") {
            return props.value;
        }
        else {
            console.info("Unhandled getConfig key = " + key);
        }
    }

    render() {
        const { language, ttsVoices } = getGlobalSettings();

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <p>
                            By default, filler prompts are assembled from the Basic Corpus of words and phrases recorded by
                            Interactions voice actors for the voices and languages used by the client application.
                            To use an external audio service to provide the prompt, enable the <strong>External Audio Prompt</strong> toggle
                            switch and specify the service URL in the <strong>External Audio Service URL</strong> field.
                        </p>
                    </div>
                </div>
                <div className="row" style={{ "paddingBottom": "20px" }}>
                <div style={{ paddingTop: "6px" }} className="col-md-4 container-align-left">
                        <LanguageSelector onChange={this.forceUpdate} />
                    </div>
                    <div style={{ paddingTop: "6px" }} className="col-md-4 container-align-left">
                        <TtsVoiceSelector onChange={this.forceUpdate} />
                    </div>
                    <div className="col-md-4"></div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <FillerPromptsSectionGroup
                            context={this}
                            language={language}
                            prompts={this.state.prompts['wait']}
                            rows={2}
                            title="Wait"
                            ttsVoices={ttsVoices}
                            type={'wait'}
                        />
                        <FillerPromptsSectionGroup
                            context={this}
                            language={language}
                            prompts={this.state.prompts['typing']}
                            rows={2}
                            title="Typing"
                            ttsVoices={ttsVoices}
                            type={'typing'}
                        />
                        <FillerPromptsSectionGroup
                            context={this}
                            language={language}
                            prompts={this.state.prompts['data_access']}
                            rows={3}
                            title="Data Access"
                            ttsVoices={ttsVoices}
                            type={'data_access'}
                        />
                    </div>
                </div>
            </div>
        );
    }

    validateInput({ currentTarget }) {
        return currentTarget.value !== '';
    }
}
